import { render, staticRenderFns } from "./ModalPlans.vue?vue&type=template&id=90522a82&scoped=true&"
import script from "./ModalPlans.vue?vue&type=script&lang=js&"
export * from "./ModalPlans.vue?vue&type=script&lang=js&"
import style0 from "./ModalPlans.vue?vue&type=style&index=0&id=90522a82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90522a82",
  null
  
)

export default component.exports